// store/college/course-management/store/actions.js
import * as types from './_actionTypes';

// Purchased Courses Actions
export const fetchPurchasedCoursesRequest = (collegeId = null) => ({
  type: types.FETCH_PURCHASED_COURSES_REQUEST,
  payload: { collegeId }
});

export const fetchPurchasedCoursesSuccess = (courses) => ({
  type: types.FETCH_PURCHASED_COURSES_SUCCESS,
  payload: courses
});

export const fetchPurchasedCoursesFailure = (error) => ({
  type: types.FETCH_PURCHASED_COURSES_FAILURE,
  payload: error
});

// All Available Courses Actions
export const fetchAllCoursesRequest = (collegeId = null) => ({
  type: types.FETCH_ALL_COURSES_REQUEST,
  payload: { collegeId }
});

export const fetchAllCoursesSuccess = (courses) => ({
  type: types.FETCH_ALL_COURSES_SUCCESS,
  payload: courses
});

export const fetchAllCoursesFailure = (error) => ({
  type: types.FETCH_ALL_COURSES_FAILURE,
  payload: error
});

// Filter and Search Actions
export const setCourseFilter = (filter) => ({
  type: types.SET_COURSE_FILTER,
  payload: filter
});

export const setCourseSearch = (searchTerm) => ({
  type: types.SET_COURSE_SEARCH,
  payload: searchTerm
});

export const setCourseView = (view) => ({
  type: types.SET_COURSE_VIEW,
  payload: view
});

export const setSelectedCourse = (course) => ({
  type: types.SET_SELECTED_COURSE,
  payload: course
});

export const toggleCourseDetailsModal = (isOpen) => ({
  type: types.TOGGLE_COURSE_DETAILS_MODAL,
  payload: isOpen
});

// Purchase Course Actions
export const purchaseCourseRequest = (courseId, collegeId) => ({
  type: types.PURCHASE_COURSE_REQUEST,
  payload: { courseId, collegeId }
});

export const purchaseCourseSuccess = (course) => ({
  type: types.PURCHASE_COURSE_SUCCESS,
  payload: course
});

export const purchaseCourseFailure = (error) => ({
  type: types.PURCHASE_COURSE_FAILURE,
  payload: error
});

export const fetchStudentEnrollmentStatsRequest = (filters = {}) => ({
  type: types.FETCH_STUDENT_ENROLLMENT_STATS_REQUEST,
  payload: filters
});

export const fetchStudentEnrollmentStatsSuccess = (stats) => ({
  type: types.FETCH_STUDENT_ENROLLMENT_STATS_SUCCESS,
  payload: stats
});

export const fetchStudentEnrollmentStatsFailure = (error) => ({
  type: types.FETCH_STUDENT_ENROLLMENT_STATS_FAILURE,
  payload: error
});

export const fetchCourseEnrollmentDetailsRequest = (courseId) => ({
  type: types.FETCH_COURSE_ENROLLMENT_DETAILS_REQUEST,
  payload: courseId
});

export const fetchCourseEnrollmentDetailsSuccess = (details) => ({
  type: types.FETCH_COURSE_ENROLLMENT_DETAILS_SUCCESS,
  payload: details
});

export const fetchCourseEnrollmentDetailsFailure = (error) => ({
  type: types.FETCH_COURSE_ENROLLMENT_DETAILS_FAILURE,
  payload: error
});

export const setEnrollmentFilter = (filter) => ({
  type: types.SET_ENROLLMENT_FILTER,
  payload: filter
});

export const setEnrollmentSort = (sort) => ({
  type: types.SET_ENROLLMENT_SORT,
  payload: sort
});

export const clearEnrollmentDetails = () => ({
  type: types.CLEAR_ENROLLMENT_DETAILS
});

export const resetCourseState = () => ({
  type: types.RESET_COURSE_STATE
});
